export default function Footer(){
    return(
        <footer>
            <p className="attribution">
            Challenge by <a rel="noreferrer" href="https://www.frontendmentor.io?ref=challenge" target="_blank">Frontend Mentor</a>. 
            Coded by <a rel="noreferrer" href="https://www.frontendmentor.io/profile/amelia2802" target="_blank">Amelia Dutta</a>.
            </p>
      </footer>
    )
}